import React from "react";
import Anime from "./anime";

const Tours = ({
  name,
  setName,
  fetchAnime,
  anime,
  removeAnime,
  err,
  setNumber,
  number,
  fetchTopAnime,
  top,
}) => {
  return (
    <>
      <div className="topAnime">
        <div className="top">
          <label htmlFor="topAnime">Search Top: </label>
          <input
            name="topAnime"
            type="number"
            value={number}
            min={0}
            onChange={(e) => setNumber(e.currentTarget.value)}
          />
        </div>
        <button onClick={() => fetchTopAnime()}>Enter number and click!</button>
      </div>
      <h1>
        Search Anime{" "}
        <img
          className="gif"
          src="https://media1.tenor.com/images/fa05b0c5a599596e82f16e4de83ac760/tenor.gif?itemid=16127844"
          alt=""
          style={{ display: "inline" }}
        />
      </h1>
      <div className="searchItems">
        {err ? <div className="err">Enter something!!</div> : ""}
        <input
          autoFocus
          placeholder="Enter anime name"
          type="text"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
        />
        <button type="button" onClick={() => fetchAnime()}>
          Search
        </button>
      </div>
      <div className="title">
        {name ? (
          <h1>anime:{name}</h1>
        ) : number > 0 ? (
          <h1>TOP:{number}</h1>
        ) : (
          <h1>Type an Anime name??</h1>
        )}
        <div className="underline"></div>
      </div>

      {/* creates top anime */}
      <div className="worldTop">
        {anime.length === 0 ? (
          <>
            <h2>Top Anime in the World</h2>

            <ul>
              {top.map((item, i) => (
                <li key={item.mal_id}>
                  {`${i + 1}. ${item.title}`}
                  <span className="topScore"> |Score: {item.score}</span>
                </li>
              ))}
            </ul>
            <p style={{ margin: 10, fontSize: 20, fontWeight: "bolder" }}>
              Rating is based on My Anime List Ratings
            </p>
          </>
        ) : (
          <p></p>
        )}
      </div>

      <section className="container">
        <div className="item-container">
          {anime.map((item) => {
            return (
              <Anime
                key={item.mal_id}
                {...item}
                removeAnime={removeAnime}
              ></Anime>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Tours;
